/*
  ============================================================
  BOVEA CART BEAUTY
  Datei vollständig ersetzen: assets/bovea-cart-beauty.js
  ============================================================
*/

(function () {
  "use strict";

  /*
    ============================================================
    BRUECKE ZUR GESCHENK-ENGINE

    Die gesamte Warenkorblogik liegt in bovea-gift-engine.js
    und ist dort getestet. Hier wird sie nur angebunden.

    Alle schreibenden Zugriffe laufen durch EINE Warteschlange.
    Ohne die ueberholen sich zwei Aufrufe gegenseitig und
    Artikel verschwinden wieder aus dem Warenkorb.
    ============================================================
  */

  var Engine = window.BoveaGiftEngine;

  var cartQueue = Promise.resolve();

  function enqueue(task) {
    var next = cartQueue.then(task, task);

    cartQueue = next.catch(function () {
      return null;
    });

    return next;
  }


  /*
    ============================================================
    EINSTELLUNGEN
    ============================================================
  */

  var GIFT_LIMIT = 3999;
  var SHIPPING_COMPARE_PRICE = 495;

  var COLLECTIONS = [
    "bestseller",
    "bad",
    "badezimmer",
    "bathroom"
  ];

  var MAX_QUICK_PRODUCTS = 16;

  /*
    Geschenk 1:
    MagClip Weiß / 6er Set zu jeder Bestellung
  */
  var MAGCLIP_PRODUCT_ID = 15896042799435;
  var MAGCLIP_VARIANT_ID = 57986212397387;
  var MAGCLIP_VALUE = 699;
  var MAGCLIP_PROPERTY = "_bovea_free_gift";

  /*
    Geschenk 2:
    Reinigungstücher 6er Set ab 89 €
  */
  var TOWEL_PRODUCT_ID = 15863835558219;
  var TOWEL_VALUE = 1699;
  var TOWEL_PROPERTY = "_bovea_threshold_gift";

  /*
    ============================================================
    PRODUKTUNTERTITEL
    ============================================================
  */

  var SUBTITLES = [
    {
      match: ["3 in 1", "reiniger"],
      text: "Streifenfrei sauber glänzend"
    },
    {
      match: ["fensterreiniger"],
      text: "Streifenfrei sauber glänzend"
    },
    {
      match: ["varioslide"],
      text: "Mehr Ordnung im Schrank"
    },
    {
      match: ["schneidebretter"],
      text: "Stilvoll schneiden & servieren"
    },
    {
      match: ["schneidebrett"],
      text: "Stilvoll schneiden & servieren"
    },
    {
      match: ["10 in 1"],
      text: "Schneller sauber schrubben"
    },
    {
      match: ["bürste"],
      text: "Schneller sauber schrubben"
    },
    {
      match: ["buerste"],
      text: "Schneller sauber schrubben"
    },
    {
      match: ["duschablage"],
      text: "Ordnung ohne Bohren"
    },
    {
      match: ["vorratsdosen"],
      text: "Frisch. Klar. Verstaut."
    },
    {
      match: ["vorratsdose"],
      text: "Frisch. Klar. Verstaut."
    }
  ];

  /*
    ============================================================
    MANUELLE VERGLEICHSPREISE
    Angaben immer in Cent
    ============================================================
  */

  var COMPARE_AT = [
    {
      match: ["3 in 1", "reiniger"],
      cents: 4999
    },
    {
      match: ["fensterreiniger"],
      cents: 4999
    },


    {
      match: ["kabelhalter", "6er"],
      cents: 998
    },
    {
      match: ["kabelclip", "6er"],
      cents: 998
    },
    {
      match: ["kabelclips", "6er"],
      cents: 998
    },
    {
      match: ["cable", "6er"],
      cents: 998
    },

    {
      match: ["kabelhalter", "12er"],
      cents: 1996
    },
    {
      match: ["kabelclip", "12er"],
      cents: 1996
    },
    {
      match: ["kabelclips", "12er"],
      cents: 1996
    },
    {
      match: ["cable", "12er"],
      cents: 1996
    }
  ];

  /*
    ============================================================
    INTERNER STATUS
    ============================================================
  */

  var latestCart = null;

  var quickProducts = null;
  var quickLoading = null;


  var towelVariantId = 0;
  var towelVariantLoading = null;

  var giftSyncLoading = null;

  var renderLock = false;
  var observerTimer = null;

  /*
    ============================================================
    GRUNDFUNKTIONEN
    ============================================================
  */

  function money(cents) {
    cents = Number(cents || 0);

    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
      })
        .format(cents / 100)
        .replace(/\s/g, "");
    } catch (error) {
      return (
        (cents / 100)
          .toFixed(2)
          .replace(".", ",") + "€"
      );
    }
  }

  function esc(value) {
    return String(
      value == null ? "" : value
    ).replace(
      /[&<>"']/g,
      function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      }
    );
  }

  /*
    Preise in Cent umrechnen.

    Shopify liefert je nach Schnittstelle unterschiedlich:
      /products/<handle>.js   ->  699      (Zahl, bereits Cent)
      /products.json          ->  "6.99"   (Text, Euro)

    Frueher stand hier eine Faustregel ("groesser als 999 ist
    schon Cent"). Damit wurde jeder Preis unter 10 Euro mit
    100 multipliziert: aus 6,99 Euro wurden 699,00 Euro. Genau
    daher kamen die absurden Vergleichspreise und die zu hohe
    Ersparnis beim MagClip. Jetzt entscheidet der Datentyp,
    nicht die Groesse der Zahl.
  */
  function cents(value) {
    if (
      value == null ||
      value === ""
    ) {
      return 0;
    }

    /* Zahl aus der .js-Schnittstelle: schon Cent. */
    if (typeof value === "number") {
      return Math.round(value);
    }

    var raw = String(value).trim();

    if (!raw) {
      return 0;
    }

    /* Text mit Komma oder Punkt: Euro. */
    if (
      raw.indexOf(".") > -1 ||
      raw.indexOf(",") > -1
    ) {
      return Math.round(
        Number(
          raw.replace(",", ".")
        ) * 100
      );
    }

    /* Text ohne Trennzeichen: als Cent lesen. */
    return Math.round(
      Number(raw) || 0
    );
  }

  function imageUrl(url, width) {
    if (!url) {
      return "";
    }

    url = String(url);

    if (url.indexOf("//") === 0) {
      url =
        window.location.protocol +
        url;
    }

    return url.replace(
      /(\.[^.\/]+)(\?.*)?$/,
      "_" + width + "x$1$2"
    );
  }

  function drawers() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        ".lh-cart-drawer, .lc-cart-drawer"
      )
    );
  }

  function bodies() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        "[data-cart-body]"
      )
    );
  }

  function getCart() {
    return fetch("/cart.js", {
      headers: {
        "Accept": "application/json"
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Cart fetch failed"
        );
      }

      return response.json();
    });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type":
          "application/json",
        "Accept":
          "application/json"
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(
          "Cart request failed"
        );
      }

      return response.json();
    });
  }

  /*
    ============================================================
    PREISE AUS DEM WARENKORB
    ============================================================
  */

  /* Was der Kunde fuer die Zeile wirklich zahlt. */
  function linePrice(item) {
    return Engine.paidLinePrice(item);
  }

  /*
    Eine einzige Preisbasis fuer den ganzen Warenkorb:
    der regulaere Stueckpreis. Frueher rechnete diese Datei
    an einer Stelle mit final_price und an anderer mit
    original_price. Genau daran ist der durchgestrichene
    Vergleichspreis verschwunden.
  */
  function unitPrice(item) {
    return Engine.unitPrice(item);
  }

  /*
    ============================================================
    GRATISGESCHENKE ERKENNEN
    ============================================================
  */

  function hasProperty(
    item,
    propertyName
  ) {
    return Boolean(
      item &&
      item.properties &&
      String(
        item.properties[propertyName]
      ) === "true"
    );
  }

  function isMagClipGift(item) {
    return Engine.giftKindOf(item) === "magclip";
  }

  function isTowelGift(item) {
    return Engine.giftKindOf(item) === "towels";
  }

  function isGift(item) {
    return Engine.isGift(item);
  }

  /*
    Das nicht gelistete 0-Euro-Produkt ist ausschliesslich ein
    automatisch verwaltetes Geschenk. Es darf niemals als normal
    gekaufter Artikel behandelt oder in der Menge erhoeht werden.
  */
  function isProtectedMagClipVariant(variantId) {
    return Number(variantId || 0) === Number(MAGCLIP_VARIANT_ID);
  }

  function giftPriority(item) {
    if (isMagClipGift(item)) {
      return 0;
    }

    if (isTowelGift(item)) {
      return 1;
    }

    return 2;
  }

  /*
    Nur bezahlte Produkte zählen
    für die 89-€-Schwelle.
  */
  /*
    Grundlage der 89-Euro-Schwelle. Muss exakt die Zahl sein,
    mit der auch Engine.plan rechnet, sonst zeigt der Drawer
    eine andere Schwelle an, als die Engine anwendet.
  */
  function eligibleTotal(cart) {
    return Engine.paidTotal(cart);
  }

  function giftValues() {
    return {
      magclip: MAGCLIP_VALUE,
      towels: TOWEL_VALUE
    };
  }

  /*
    ============================================================
    ERSTE VERFÜGBARE VARIANTE
    ============================================================
  */

  function firstVariant(product) {
    if (
      !product ||
      !Array.isArray(
        product.variants
      ) ||
      !product.variants.length
    ) {
      return null;
    }

    for (
      var index = 0;
      index < product.variants.length;
      index += 1
    ) {
      if (
        product.variants[index]
          .available !== false
      ) {
        return product.variants[index];
      }
    }

    return product.variants[0];
  }

  /*
    ============================================================
    REINIGUNGSTÜCHER-PRODUKT FINDEN
    ============================================================
  */

  function findTowel(products) {
    var foundProduct = null;

    (products || []).some(
      function (product) {
        if (
          Number(product.id) ===
          Number(TOWEL_PRODUCT_ID)
        ) {
          foundProduct = product;
          return true;
        }

        return false;
      }
    );

    if (foundProduct) {
      return foundProduct;
    }

    (products || []).some(
      function (product) {
        var productTitle = String(
          product.title || ""
        ).toLowerCase();

        if (
          productTitle.indexOf(
            "reinigungstücher"
          ) !== -1 &&
          productTitle.indexOf(
            "6er"
          ) !== -1
        ) {
          foundProduct = product;
          return true;
        }

        return false;
      }
    );

    return foundProduct;
  }

  /*
    ============================================================
    REINIGUNGSTÜCHER-VARIANTE LADEN
    Wird erst ab 89 € ausgeführt.
    ============================================================
  */

  function resolveTowelVariant() {
    if (towelVariantId) {
      return Promise.resolve(
        towelVariantId
      );
    }

    if (towelVariantLoading) {
      return towelVariantLoading;
    }

    towelVariantLoading = fetch(
      "/products.json?limit=250",
      {
        headers: {
          "Accept": "application/json"
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Products failed"
          );
        }

        return response.json();
      })
      .then(function (data) {
        var products =
          data &&
          Array.isArray(
            data.products
          )
            ? data.products
            : [];

        var product =
          findTowel(products);

        var variant =
          firstVariant(product);

        if (
          !variant ||
          !variant.id
        ) {
          throw new Error(
            "Towel not found"
          );
        }

        towelVariantId =
          Number(variant.id);

        return towelVariantId;
      })
      .catch(function () {
        return fetch(
          "/search/suggest.json?q=" +
            encodeURIComponent(
              "Reinigungstücher 6er Set"
            ) +
            "&resources[type]=product" +
            "&resources[limit]=10",
          {
            headers: {
              "Accept":
                "application/json"
            }
          }
        )
          .then(function (response) {
            if (!response.ok) {
              throw new Error(
                "Search failed"
              );
            }

            return response.json();
          })
          .then(function (data) {
            var products =
              data &&
              data.resources &&
              data.resources.results &&
              Array.isArray(
                data.resources.results
                  .products
              )
                ? data.resources.results
                    .products
                : [];

            var product =
              findTowel(products);

            if (!product) {
              throw new Error(
                "Towel search failed"
              );
            }

            var handle =
              product.handle || "";

            if (
              !handle &&
              product.url
            ) {
              var handleMatch =
                String(
                  product.url
                ).match(
                  /\/products\/([^?\/#]+)/
                );

              handle =
                handleMatch &&
                handleMatch[1]
                  ? handleMatch[1]
                  : "";
            }

            if (!handle) {
              throw new Error(
                "Handle missing"
              );
            }

            return fetch(
              "/products/" +
                encodeURIComponent(
                  handle
                ) +
                ".js",
              {
                headers: {
                  "Accept":
                    "application/json"
                }
              }
            );
          })
          .then(function (response) {
            if (!response.ok) {
              throw new Error(
                "Product failed"
              );
            }

            return response.json();
          })
          .then(function (product) {
            var variant =
              firstVariant(product);

            if (
              !variant ||
              !variant.id
            ) {
              throw new Error(
                "Variant missing"
              );
            }

            towelVariantId =
              Number(variant.id);

            return towelVariantId;
          });
      })
      .catch(function () {
        towelVariantId = 0;
        return 0;
      })
      .then(function (variantId) {
        towelVariantLoading = null;
        return variantId;
      });

    return towelVariantLoading;
  }

  /*
    ============================================================
    WARENKORB-ÄNDERUNGEN FÜR GESCHENKE
    ============================================================
  */

  /*
    ============================================================
    GRATISGESCHENKE SYNCHRONISIEREN
    ============================================================
  */

  var towelVariantCache = null;

  function giftConfig() {
    return {
      limit: GIFT_LIMIT,
      gifts: []
    };
  }

  var cartApi = {
    get: function () {
      return getCart();
    },
    add: function (payload) {
      return postCart("/cart/add.js", payload);
    },
    change: function (payload) {
      return postCart("/cart/change.js", payload);
    }
  };

  /*
    Nach einer eigenen Mengenoperation ist deren Serverantwort
    bereits der aktuelle Warenkorb und wird direkt weitergenutzt.
    Bei einem freien Refresh wird der Warenkorb neu geladen.
  */
  function syncGifts(cartHint) {
    return enqueue(function () {
      var prepare = towelVariantCache
        ? Promise.resolve(towelVariantCache)
        : resolveTowelVariant().then(function (id) {
            towelVariantCache = id ? Number(id) : null;
            return towelVariantCache;
          });

      return prepare
        .catch(function () {
          return null;
        })
        .then(function () {
          return cartHint || getCart();
        })
        .then(function (fresh) {
          /*
            settle rechnet, fuehrt aus und prueft danach noch
            einmal nach. Damit bleibt kein halb aufgeraeumter
            Warenkorb stehen, wenn zwischendurch etwas
            dazwischenfunkt.
          */
          return Engine.settle(
            fresh,
            giftConfig(),
            cartApi
          );
        })
        .catch(function () {
          return getCart();
        });
    });
  }

  /*
    Entfernt jede unmarkierte Kopie des geschuetzten 0-Euro-
    MagClip-Produkts und begrenzt die echte Geschenkzeile auf 1.

    Damit kann die Variante weder ueber eine Produktseite noch
    ueber einen fremden Add-to-cart-Button mehrfach kostenlos im
    Warenkorb verbleiben.
  */
  function sanitizeProtectedMagClip(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return Promise.resolve(cart);
    }

    var updates = {};
    var keptGift = false;

    cart.items.forEach(function (item) {
      if (!isProtectedMagClipVariant(item.variant_id)) {
        return;
      }

      var authorizedGift = isMagClipGift(item);

      if (authorizedGift && !keptGift) {
        keptGift = true;

        if (Number(item.quantity || 0) !== 1 && item.key) {
          updates[item.key] = 1;
        }

        return;
      }

      if (item.key) {
        updates[item.key] = 0;
      }
    });

    if (!Object.keys(updates).length) {
      return Promise.resolve(cart);
    }

    return postCart(
      "/cart/update.js",
      { updates: updates }
    ).then(function () {
      return getCart();
    });
  }

  /*
    Vor dem Geschenk-Abgleich werden unerlaubte 0-Euro-Kopien
    entfernt. Danach wird noch einmal kontrolliert, dass exakt
    eine echte Geschenkzeile mit Menge 1 uebrig bleibt.
  */
  function secureGiftSync(cartHint) {
    return enqueue(function () {
      var source = cartHint
        ? Promise.resolve(cartHint)
        : getCart();

      return source.then(function (fresh) {
        if (!fresh || !Array.isArray(fresh.items)) {
          return fresh;
        }

        var updates = {};

        fresh.items.forEach(function (item) {
          if (isGift(item) && item.key) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) {
          return fresh;
        }

        return postCart(
          "/cart/update.js",
          { updates: updates }
        ).then(function () {
          return getCart();
        });
      });
    }).catch(function () {
      return getCart();
    });
  }

  /*
    ============================================================
    SCHNELL-HINZUFÜGEN-PRODUKTE
    ============================================================
  */

  function productImage(product) {
    if (!product) {
      return "";
    }

    if (
      product.featured_image
    ) {
      if (
        typeof product
          .featured_image ===
        "string"
      ) {
        return product
          .featured_image;
      }

      if (
        product.featured_image
          .src
      ) {
        return product
          .featured_image.src;
      }
    }

    if (product.image) {
      if (
        typeof product.image ===
        "string"
      ) {
        return product.image;
      }

      if (product.image.src) {
        return product.image.src;
      }
    }

    if (
      product.images &&
      product.images.length
    ) {
      if (
        typeof product.images[0] ===
        "string"
      ) {
        return product.images[0];
      }

      if (
        product.images[0].src
      ) {
        return product.images[0].src;
      }
    }

    return "";
  }

  function normalizeProduct(product) {
    var variant =
      firstVariant(product);

    if (
      !product ||
      !variant ||
      !variant.id
    ) {
      return null;
    }

    return {
      productId:
        Number(product.id || 0),

      variantId:
        Number(variant.id),

      handle:
        product.handle || "",

      title:
        product.title ||
        "Bovea Produkt",

      image:
        productImage(product),

      price:
        cents(
          variant.price ||
          product.price
        ),

      compareAt:
        cents(
          variant.compare_at_price ||
          product.compare_at_price
        ),

      available:
        variant.available !== false
    };
  }

  function loadQuickProducts() {
    if (quickProducts) {
      return Promise.resolve(
        quickProducts
      );
    }

    if (quickLoading) {
      return quickLoading;
    }

    function loadCollection(
      handle
    ) {
      return fetch(
        "/collections/" +
          encodeURIComponent(handle) +
          "/products.json?limit=" +
          MAX_QUICK_PRODUCTS,
        {
          headers: {
            "Accept":
              "application/json"
          }
        }
      )
        .then(function (response) {
          if (!response.ok) {
            return [];
          }

          return response.json();
        })
        .then(function (data) {
          return (
            data &&
            Array.isArray(
              data.products
            )
              ? data.products
              : []
          );
        })
        .catch(function () {
          return [];
        });
    }

    quickLoading = Promise.all(
      COLLECTIONS.map(
        loadCollection
      )
    )
      .then(function (groups) {
        var seen = {};
        var result = [];

        groups.forEach(
          function (products) {
            products.forEach(
              function (product) {
                var normalized =
                  normalizeProduct(
                    product
                  );

                if (
                  !normalized ||
                  !normalized.available ||
                  !normalized.variantId ||
                  Number(normalized.productId || 0) === Number(MAGCLIP_PRODUCT_ID) ||
                  isProtectedMagClipVariant(normalized.variantId)
                ) {
                  return;
                }

                var key =
                  normalized.productId ||
                  normalized.handle ||
                  normalized.variantId;

                if (seen[key]) {
                  return;
                }

                seen[key] = true;

                result.push(
                  normalized
                );
              }
            );
          }
        );

        quickProducts =
          result.slice(
            0,
            MAX_QUICK_PRODUCTS
          );

        return quickProducts;
      })
      .catch(function () {
        quickProducts = [];
        return quickProducts;
      });

    return quickLoading;
  }

  function cartKeys(cart) {
    var keys = {};

    (
      cart &&
      cart.items
        ? cart.items
        : []
    ).forEach(function (item) {
      if (item.product_id) {
        keys[
          "product:" +
          item.product_id
        ] = true;
      }

      if (item.variant_id) {
        keys[
          "variant:" +
          item.variant_id
        ] = true;
      }

      if (item.handle) {
        keys[
          "handle:" +
          item.handle
        ] = true;
      }
    });

    return keys;
  }

  function productInCart(
    product,
    keys
  ) {
    return Boolean(
      (
        product.productId &&
        keys[
          "product:" +
          product.productId
        ]
      ) ||
      (
        product.variantId &&
        keys[
          "variant:" +
          product.variantId
        ]
      ) ||
      (
        product.handle &&
        keys[
          "handle:" +
          product.handle
        ]
      )
    );
  }

  /*
    ============================================================
    PRODUKTSUCHTEXT
    ============================================================
  */

  function itemSearchText(item) {
    var parts = [];

    if (!item) {
      return "";
    }

    if (item.product_title) {
      parts.push(
        item.product_title
      );
    }

    if (item.title) {
      parts.push(item.title);
    }

    if (item.handle) {
      parts.push(item.handle);
    }

    if (item.url) {
      parts.push(item.url);
    }

    if (
      item.variant_title &&
      item.variant_title !==
        "Default Title"
    ) {
      parts.push(
        item.variant_title
      );
    }

    if (
      item.options_with_values &&
      item.options_with_values
        .length
    ) {
      item.options_with_values
        .forEach(function (option) {
          if (
            option &&
            option.value &&
            option.value !==
              "Default Title"
          ) {
            parts.push(
              option.value
            );
          }
        });
    }

    return parts
      .join(" ")
      .toLowerCase();
  }

  function matchRule(
    item,
    rules
  ) {
    var searchText =
      itemSearchText(item);

    for (
      var index = 0;
      index < rules.length;
      index += 1
    ) {
      var rule = rules[index];
      var matches = true;

      for (
        var matchIndex = 0;
        matchIndex <
          rule.match.length;
        matchIndex += 1
      ) {
        if (
          searchText.indexOf(
            String(
              rule.match[
                matchIndex
              ]
            ).toLowerCase()
          ) === -1
        ) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return rule;
      }
    }

    return null;
  }

  /*
    ============================================================
    UNTERTITEL DES WARENKORBARTIKELS
    ============================================================
  */

  function variantText(item) {
    if (!item) {
      return "";
    }

    if (
      item.properties &&
      item.properties
        ._bovea_subtitle
    ) {
      return String(
        item.properties
          ._bovea_subtitle
      );
    }

    if (
      item.variant_title &&
      item.variant_title !==
        "Default Title"
    ) {
      return item.variant_title;
    }

    if (
      item.options_with_values &&
      item.options_with_values
        .length
    ) {
      var values =
        item.options_with_values
          .map(function (option) {
            return option.value;
          })
          .filter(function (value) {
            return (
              value &&
              value !==
                "Default Title"
            );
          });

      if (values.length) {
        return values.join(" / ");
      }
    }

    var rule =
      matchRule(
        item,
        SUBTITLES
      );

    return rule
      ? rule.text
      : "";
  }

  function itemImage(item) {
    var image =
      item &&
      item.image
        ? item.image
        : "";

    if (
      !image &&
      item &&
      item.featured_image
    ) {
      if (
        typeof item
          .featured_image ===
        "string"
      ) {
        image =
          item.featured_image;
      } else if (
        item.featured_image.url
      ) {
        image =
          item.featured_image.url;
      } else if (
        item.featured_image.src
      ) {
        image =
          item.featured_image.src;
      }
    }

    return image;
  }

  function manualCompare(item) {
    var rule =
      matchRule(
        item,
        COMPARE_AT
      );

    return rule
      ? Number(rule.cents || 0)
      : 0;
  }

  function compareLine(item) {
    var compareAt =
      Number(
        item &&
        item.bovea_compare_at
          ? item.bovea_compare_at
          : 0
      ) ||
      manualCompare(item);

    if (
      compareAt >
      unitPrice(item)
    ) {
      return (
        compareAt *
        Number(
          item.quantity || 1
        )
      );
    }

    return 0;
  }

  function itemPriceHtml(item) {
    var compare =
      compareLine(item);

    /*
      Engine.unitPrice statt linePrice. Sonst schlaegt eine
      von Shopify quer verteilte Rabattzuordnung durch und
      die selbst gekaufte Kopie des Geschenks saehe gratis aus.
    */
    var current =
      Engine.unitPrice(item) *
      Number(item.quantity || 1);

    if (compare > current) {
      return (
        '<div class="bovea-cart-price-stack">' +
          '<strong class="bovea-cart-item-price">' +
            money(current) +
          '</strong>' +
          '<s class="bovea-cart-item-compare">' +
            money(compare) +
          '</s>' +
        '</div>'
      );
    }

    return (
      '<strong class="bovea-cart-item-price">' +
        money(current) +
      '</strong>'
    );
  }

  /*
    ============================================================
    PRODUKT-HANDLE ERMITTELN
    ============================================================
  */

  function productHandle(item) {
    if (!item) {
      return "";
    }

    if (item.handle) {
      return item.handle;
    }

    if (!item.url) {
      return "";
    }

    var handleMatch =
      String(item.url).match(
        /\/products\/([^?\/#]+)/
      );

    return (
      handleMatch &&
      handleMatch[1]
        ? handleMatch[1]
        : ""
    );
  }

  /*
    ============================================================
    ERSPARNIS EINER VARIANTE ERMITTELN
    ============================================================
  */

  /*
    ============================================================
    VERGLEICHSPREISE

    Der Vergleichspreis einer Variante wird genau einmal beim
    Shop erfragt und danach im Speicher gehalten. Entscheidend:
    er wird bei JEDEM Rendern wieder an die Zeile geschrieben.

    Frueher landete er nur beim allerersten Rendern am Artikel.
    Danach griff der Zwischenspeicher, die Zeile bekam nichts
    mehr, und die durchgestrichene Zahl war weg, sobald man die
    Menge geaendert hat.

    Fehlgeschlagene Abfragen werden bewusst NICHT gemerkt,
    sonst bleibt ein einzelner Netzfehler dauerhaft haengen.
    ============================================================
  */

  var compareCache = {};
  var compareLoading = {};

  function productOptionNames(product) {
    return ((product && product.options) || []).map(function (option) {
      if (typeof option === "string") {
        return option;
      }

      return option && option.name
        ? option.name
        : "";
    });
  }

  function setQuantity(value) {
    var match = String(value || "").match(/\d+/);
    return match ? Math.max(Number(match[0]) || 1, 1) : 1;
  }

  function isVarioSlideItem(item, product) {
    var haystack = [
      item && item.product_title,
      item && item.title,
      product && product.title,
      item && item.handle,
      product && product.handle
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return (
      haystack.indexOf("varioslide") !== -1 ||
      haystack.indexOf("schrankauszug") !== -1 ||
      haystack.indexOf("ausziehbare schubl") !== -1
    );
  }

  /*
    VarioSlide nutzt auf der Produktseite bewusst den Preis des
    1er-Sets als Vergleichsbasis für 2er und 4er. Genau dieselbe
    Logik wird hier im Warenkorb nachgebaut – für jede Farbe und
    beide Breiten automatisch, ohne feste Variant-IDs.
  */
  function varioSlideCompare(product, variant, item) {
    if (!isVarioSlideItem(item, product) || !variant) {
      return 0;
    }

    var optionNames = productOptionNames(product);
    var setIndex = -1;

    optionNames.some(function (name, index) {
      var normalized = String(name || "").toLowerCase();

      if (
        normalized.indexOf("set") !== -1 ||
        normalized.indexOf("menge") !== -1 ||
        normalized.indexOf("anzahl") !== -1
      ) {
        setIndex = index;
        return true;
      }

      return false;
    });

    if (setIndex < 0 && item && item.options_with_values) {
      item.options_with_values.some(function (option, index) {
        var normalized = String(option && option.name || "").toLowerCase();

        if (
          normalized.indexOf("set") !== -1 ||
          normalized.indexOf("menge") !== -1 ||
          normalized.indexOf("anzahl") !== -1
        ) {
          setIndex = index;
          return true;
        }

        return false;
      });
    }

    if (setIndex < 0) {
      return 0;
    }

    var currentOptions =
      variant.options && variant.options.length
        ? variant.options.slice()
        : [variant.option1, variant.option2, variant.option3].filter(function (value) {
            return value != null;
          });

    var currentQuantity = setQuantity(currentOptions[setIndex]);
    var currentPrice = cents(variant.price);
    var exactCompare = cents(variant.compare_at_price);
    var normalizedOptions = currentOptions.map(function (value) {
      return String(value || "").trim().toLowerCase();
    });
    var isBlackSmallVarioSlide =
      normalizedOptions.some(function (value) {
        return value.indexOf("schwarz") !== -1 || value.indexOf("black") !== -1;
      }) &&
      normalizedOptions.some(function (value) {
        return /32\s*[-–—]\s*52|32.*52/.test(value);
      });

    /*
      Kleine schwarze 32–52-cm-Variante auf denselben
      Vergleichspreis wie die weiße Variante normalisieren.
    */
    if (currentQuantity <= 1 && isBlackSmallVarioSlide) {
      return 3799 > currentPrice ? 3799 : 0;
    }

    /* Beim 1er-Set gilt ansonsten weiterhin der echte Shopify-Vergleichspreis. */
    if (currentQuantity <= 1) {
      return exactCompare > currentPrice
        ? exactCompare
        : 0;
    }

    var baseVariant = null;
    var baseQuantity = Infinity;

    (product.variants || []).forEach(function (candidate) {
      var candidateOptions =
        candidate.options && candidate.options.length
          ? candidate.options
          : [candidate.option1, candidate.option2, candidate.option3].filter(function (value) {
              return value != null;
            });

      if (!candidateOptions.length) {
        return;
      }

      var sameConfiguration = currentOptions.every(function (value, index) {
        if (index === setIndex) {
          return true;
        }

        return String(candidateOptions[index] || "").trim().toLowerCase() ===
          String(value || "").trim().toLowerCase();
      });

      if (!sameConfiguration) {
        return;
      }

      var candidateQuantity = setQuantity(candidateOptions[setIndex]);

      if (candidateQuantity < baseQuantity) {
        baseQuantity = candidateQuantity;
        baseVariant = candidate;
      }
    });

    if (!baseVariant || !isFinite(baseQuantity) || baseQuantity <= 0) {
      return exactCompare > currentPrice
        ? exactCompare
        : 0;
    }

    var baseUnitPrice = cents(baseVariant.price) / baseQuantity;
    var calculatedCompare = Math.round(baseUnitPrice * currentQuantity);

    if (calculatedCompare > currentPrice) {
      return calculatedCompare;
    }

    return exactCompare > currentPrice
      ? exactCompare
      : 0;
  }

  function compareFromProduct(handle, variantId, item) {
    var cacheKey = String(variantId);

    if (
      Object.prototype.hasOwnProperty.call(
        compareCache,
        cacheKey
      )
    ) {
      return Promise.resolve(
        compareCache[cacheKey]
      );
    }

    if (compareLoading[cacheKey]) {
      return compareLoading[cacheKey];
    }

    compareLoading[cacheKey] = fetch(
      "/products/" +
        encodeURIComponent(handle) +
        ".js",
      {
        headers: {
          "Accept": "application/json"
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Produkt nicht erreichbar");
        }

        return response.json();
      })
      .then(function (product) {
        var variant = null;

        (product.variants || []).some(
          function (candidate) {
            if (
              Number(candidate.id) ===
              Number(variantId)
            ) {
              variant = candidate;
              return true;
            }

            return false;
          }
        );

        if (!variant) {
          throw new Error("Variante nicht gefunden");
        }

        var price = cents(variant.price);

        var compareAt = cents(
          variant.compare_at_price
        );

        var varioCompare = varioSlideCompare(
          product,
          variant,
          item
        );

        var value =
          varioCompare > price
            ? varioCompare
            : (compareAt > price ? compareAt : 0);

        compareCache[cacheKey] = value;

        return value;
      })
      .catch(function () {
        /* Nicht merken, beim naechsten Rendern neu versuchen. */
        return 0;
      })
      .then(function (value) {
        delete compareLoading[cacheKey];
        return value;
      });

    return compareLoading[cacheKey];
  }

  /*
    Schreibt den Vergleichspreis an die Zeile. Erst die feste
    Liste, danach der Shop. Ohne Treffer bleibt das Feld leer
    und die Zeile zeigt nur den echten Preis.
  */
  function applyCompare(item) {
    var manual = manualCompare(item);

    if (manual > unitPrice(item)) {
      item.bovea_compare_at = manual;

      return Promise.resolve(item);
    }

    var handle = productHandle(item);

    var variantId = Number(
      item && item.variant_id
        ? item.variant_id
        : 0
    );

    if (!handle || !variantId) {
      return Promise.resolve(item);
    }

    return compareFromProduct(
      handle,
      variantId,
      item
    ).then(function (compareAt) {
      if (compareAt > unitPrice(item)) {
        item.bovea_compare_at = compareAt;
      }

      return item;
    });
  }

  /*
    ============================================================
    VERGLEICHSPREISE UND ERSPARNIS AM WARENKORB ERGAENZEN
    ============================================================
  */

  function enrichSavings(cart) {
    if (
      !cart ||
      !cart.items ||
      !cart.items.length
    ) {
      if (cart) {
        cart.bovea_savings = 0;
      }

      return Promise.resolve(cart);
    }

    return Promise.all(
      cart.items.map(function (item) {
        var kind = Engine.giftKindOf(item);

        if (kind) {
          item.bovea_compare_at =
            Number(
              giftValues()[kind] || 0
            );

          return Promise.resolve(item);
        }

        return applyCompare(item);
      })
    ).then(function () {
      /*
        Eine einzige Ersparnisrechnung fuer alle Anzeigen:
        Vergleichspreise minus tatsaechlich gezahlter Betrag.
        Die Geschenkwerte stecken darin automatisch mit drin.
      */
      cart.bovea_savings = Engine.totals(
        cart,
        giftValues()
      ).savings;

      return cart;
    });
  }

  /*
    ============================================================
    WARENKORBARTIKEL HTML
    ============================================================
  */

  function itemHtml(item) {
    var magClipGift =
      isMagClipGift(item);

    var towelGift =
      isTowelGift(item);

    var gift =
      magClipGift ||
      towelGift;

    var title =
      item.product_title ||
      item.title ||
      "Bovea Produkt";

    var subtitle =
      variantText(item);

    var image =
      itemImage(item);

    var url =
      item.url || "#";

    var giftValue = 0;

    if (magClipGift) {
      title =
        "Kabelorganizer 6er Set";

      subtitle =
        "Weiß / 6er Set";

      giftValue =
        MAGCLIP_VALUE;
    }

    if (towelGift) {
      title =
        "Reinigungstücher 6er Set";

      subtitle =
        "6er Set";

      giftValue =
        TOWEL_VALUE;
    }

    var quantityHtml = gift
      ? (
          '<div class="bovea-cart-gift-label">' +
            '1x Gratisgeschenk' +
          '</div>'
        )
      : (
          '<div class="bovea-cart-qty">' +
            '<button type="button" data-bovea-minus aria-label="Menge verringern">−</button>' +
            '<span data-bovea-qty>' +
              Number(
                item.quantity || 1
              ) +
            '</span>' +
            '<button type="button" data-bovea-plus aria-label="Menge erhöhen">+</button>' +
          '</div>'
        );

    var priceHtml = gift
      ? (
          '<div class="bovea-cart-price-stack">' +
            '<strong class="bovea-cart-item-price bovea-cart-gift-free">' +
              'Kostenlos' +
            '</strong>' +
            '<s class="bovea-cart-item-compare">' +
              money(giftValue) +
            '</s>' +
          '</div>'
        )
      : itemPriceHtml(item);

    var removeHtml = gift
      ? ""
      : (
          '<button class="bovea-cart-remove" type="button" data-bovea-remove aria-label="Artikel entfernen">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true">' +
              '<path d="M8 8v10m4-10v10m4-10v10M5 5h14M9 5V3h6v2m3 0-1 16H7L6 5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>'
        );

    /*
      Geschenkbild und Geschenktitel sind bewusst keine Links.
      Das nicht gelistete 0-Euro-Produkt darf aus dem Drawer nicht
      als normale Produktseite erreichbar sein.
    */
    var displayUrl = url;

    var giftDisplayUrls = window.BoveaGiftDisplayUrls || {};

    if (magClipGift) {
      displayUrl =
        giftDisplayUrls.magclip ||
        "/search?q=MagClip%206er%20Set";
    }

    if (towelGift) {
      displayUrl =
        giftDisplayUrls.towels ||
        "/search?q=Reinigungst%C3%BCcher%206er%20Set";
    }

    var giftKind = magClipGift
      ? "magclip"
      : (towelGift ? "towels" : "");

    var giftLinkAttribute = giftKind
      ? ' data-bovea-gift-link="' + esc(giftKind) + '"'
      : '';

    var mediaOpen = '<a class="bovea-cart-item-img" href="' + esc(displayUrl) + '"' + giftLinkAttribute + ' aria-label="' + esc(title) + ' ansehen">';
    var mediaClose = '</a>';

    var titleHtml = '<a class="bovea-cart-item-title" href="' + esc(displayUrl) + '"' + giftLinkAttribute + '>' +
      esc(title) +
    '</a>';

    return (
      '<article class="bovea-cart-item' +
        (
          gift
            ? ' bovea-cart-gift-item'
            : ''
        ) +
        '" data-bovea-cart-item data-key="' +
        esc(
          item.key ||
          item.variant_id ||
          item.id
        ) +
        '" data-variant-id="' +
        esc(item.variant_id || "") +
      '">' +

        mediaOpen +
          (
            image
              ? '<img src="' +
                  esc(
                    imageUrl(
                      image,
                      220
                    )
                  ) +
                  '" alt="' +
                  esc(title) +
                  '" loading="lazy">'
              : ""
          ) +
        mediaClose +

        '<div class="bovea-cart-item-mid">' +
          titleHtml +

          (
            subtitle
              ? '<div class="bovea-cart-item-variant">' +
                  esc(subtitle) +
                '</div>'
              : ""
          ) +

          quantityHtml +
        '</div>' +

        '<div class="bovea-cart-item-right">' +
          priceHtml +
          removeHtml +
        '</div>' +

      '</article>'
    );
  }

  /*
    ============================================================
    SCHNELL-HINZUFÜGEN HTML
    ============================================================
  */

  function quickHtml(cart) {
    var keys =
      cartKeys(cart);

    var products =
      (quickProducts || [])
        .filter(function (
          product
        ) {
          return !productInCart(
            product,
            keys
          );
        })
        .slice(
          0,
          MAX_QUICK_PRODUCTS
        );

    if (!products.length) {
      return "";
    }

    var cards =
      products.map(
        function (product) {
          var href =
            product.handle
              ? "/products/" +
                product.handle
              : "#";

          var compare =
            product.compareAt >
            product.price
              ? '<s>' +
                  money(
                    product.compareAt
                  ) +
                '</s>'
              : "";

          return (
            '<article class="bovea-quick-card">' +

              '<a class="bovea-quick-img" href="' +
                esc(href) +
              '">' +
                (
                  product.image
                    ? '<img src="' +
                        esc(
                          imageUrl(
                            product.image,
                            220
                          )
                        ) +
                        '" alt="' +
                        esc(
                          product.title
                        ) +
                        '" loading="lazy">'
                    : ""
                ) +
              '</a>' +

              '<div class="bovea-quick-info">' +
                '<a class="bovea-quick-title" href="' +
                  esc(href) +
                '">' +
                  esc(
                    product.title
                  ) +
                '</a>' +

                '<div class="bovea-quick-price">' +
                  '<span>' +
                    money(
                      product.price
                    ) +
                  '</span>' +
                  compare +
                '</div>' +
              '</div>' +

              '<button class="bovea-quick-add" type="button" data-bovea-quick-add ' +
                'data-variant-id="' +
                product.variantId +
                '" aria-label="' +
                esc(
                  product.title
                ) +
                ' hinzufügen">+</button>' +

            '</article>'
          );
        }
      ).join("");

    var dots =
      products.map(
        function (_, index) {
          return (
            '<span class="bovea-quick-dot' +
              (
                index === 0
                  ? ' is-active'
                  : ''
              ) +
            '"></span>'
          );
        }
      ).join("");

    return (
      '<section class="bovea-quick-box" data-bovea-quick-box>' +

        '<div class="bovea-quick-head">' +
          '<strong>Schnell hinzufügen</strong>' +
          '<small>Bestseller & Bad</small>' +
        '</div>' +

        '<div class="bovea-quick-track" data-bovea-quick-track>' +
          cards +
        '</div>' +

        '<div class="bovea-quick-dots">' +
          dots +
        '</div>' +

      '</section>'
    );
  }

  /*
    ============================================================
    HOHE NACHFRAGE UND GESCHENKLEISTE
    ============================================================
  */

  function freeShippingHtml(cart) {
    var sums = Engine.totals(cart, giftValues());
    var merchandiseTotal = Number(sums.total || 0);
    var remaining = Math.max(GIFT_LIMIT - merchandiseTotal, 0);
    var progress = GIFT_LIMIT > 0
      ? Math.min(Math.max((merchandiseTotal / GIFT_LIMIT) * 100, 0), 100)
      : 100;
    var marker = Math.min(Math.max(progress, 4), 96);

    if (remaining <= 0) {
      return (
        '<section class="bovea-shipping-milestone is-complete" aria-live="polite">' +
          '<div class="bovea-shipping-success">' +
            '<span>Herzlichen Glückwunsch</span>' +
            '<strong>Du hast Gratis Versand freigeschaltet</strong>' +
          '</div>' +
        '</section>'
      );
    }

    return (
      '<section class="bovea-shipping-milestone" aria-live="polite">' +
        '<div class="bovea-shipping-copy">' +
          '<strong class="bovea-shipping-rate">Standardversand 4,95 €</strong>' +
          '<span>Noch ' + money(remaining) + ' bis Gratis Versand ab 39,99 €</span>' +
        '</div>' +
        '<div class="bovea-shipping-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(progress) + '">' +
          '<span class="bovea-shipping-progress__fill" style="width:' + progress.toFixed(2) + '%"></span>' +
          '<span class="bovea-shipping-progress__marker" style="left:' + marker.toFixed(2) + '%" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
          '</span>' +
        '</div>' +
        '<div class="bovea-shipping-labels">' +
          '<span>' + money(merchandiseTotal) + '</span>' +
          '<span>' + money(GIFT_LIMIT) + '</span>' +
        '</div>' +
      '</section>'
    );
  }

  function extrasHtml(cart) {
    return (
      '<div class="bovea-cart-scroll">' +
        '<div class="bovea-demand-box">' +
          '<span class="bovea-demand-icon">i</span>' +
          '<span>Hohe Nachfrage. Deine Artikel sind noch nicht reserviert. Geh jetzt zur Kasse, bevor sie weg sind.</span>' +
        '</div>' +
        freeShippingHtml(cart) +
        quickHtml(cart) +
      '</div>'
    );
  }

  /*
    ============================================================
    FESTER WARENKORB-FOOTER
    ============================================================
  */

  function footerHtml(cart) {
    var sums = Engine.totals(cart, giftValues());
    var merchandiseTotal = Number(sums.total || 0);
    var savings = Number(sums.savings || 0);
    var freeShipping = merchandiseTotal >= GIFT_LIMIT;
    var shippingCost = freeShipping ? 0 : SHIPPING_COMPARE_PRICE;
    var displayedTotal = merchandiseTotal + shippingCost;

    var savingsHtml = savings > 0
      ? (
          '<div class="bovea-savings-note">' +
            '<span>Deine Summer Sale Ersparnis</span>' +
            '<strong>' + money(savings) + '</strong>' +
          '</div>'
        )
      : "";

    return (
      savingsHtml +

      '<div class="bovea-total-list">' +
        '<div class="bovea-total-row">' +
          '<span>Zwischensumme</span>' +
          '<strong>' + money(merchandiseTotal) + '</strong>' +
        '</div>' +

        '<div class="bovea-total-row">' +
          '<span>Standardversand</span>' +
          '<strong class="' + (freeShipping ? 'bovea-shipping-free' : 'bovea-shipping-paid') + '">' +
            (freeShipping ? 'Kostenlos' : money(shippingCost)) +
          '</strong>' +
        '</div>' +

        '<div class="bovea-total-row bovea-total-final">' +
          '<span>Gesamt</span>' +
          '<strong>' + money(displayedTotal) + '</strong>' +
        '</div>' +
      '</div>' +

      '<a class="bovea-checkout" href="/checkout" aria-label="Sicher zur Kasse">' +
        '<svg class="bovea-checkout-lock" viewBox="0 0 24 24" aria-hidden="true">' +
          '<rect x="5" y="10" width="14" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/>' +
          '<path d="M8 10V7a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
        '</svg>' +
        '<span>Sicher zur Kasse</span>' +
      '</a>' +

      '<div class="bovea-trust-line">' +
        '30 Tage Geld zurück · Über 1.000 zufriedene Kunden' +
      '</div>'
    );
  }

  function updateCounts(cart) {
    if (
      !cart ||
      typeof cart.item_count !==
        "number"
    ) {
      return;
    }

    document
      .querySelectorAll(
        ".lh-cart-count, .lc-cart-count"
      )
      .forEach(function (count) {
        count.textContent =
          cart.item_count;
      });

    document
      .querySelectorAll(
        ".cart-count-bubble, [data-cart-count-bubble]"
      )
      .forEach(function (bubble) {
        var target =
          bubble.querySelector(
            "[aria-hidden='true']"
          ) ||
          bubble.querySelector(
            "span:not(.visually-hidden)"
          ) ||
          bubble;

        target.textContent =
          cart.item_count;

        bubble.style.display =
          cart.item_count > 0
            ? ""
            : "none";
      });
  }

  /*
    ============================================================
    WARENKORB RENDERN
    ============================================================
  */

  function render(cart) {
    if (!cart) {
      return;
    }

    latestCart = cart;
    renderLock = true;

    updateCounts(cart);

    drawers().forEach(
      function (drawer) {
        drawer.classList.add(
          "bovea-cart-beauty"
        );

        var cartTitle = drawer.querySelector(
          ".lh-cart-title, .lc-cart-title"
        );

        if (cartTitle) {
          cartTitle.textContent =
            "Warenkorb (" +
            Number(cart.item_count || 0) +
            ")";
        }

        var body =
          drawer.querySelector(
            "[data-cart-body]"
          );

        var foot =
          drawer.querySelector(
            "[data-cart-foot]"
          );

        if (!body) {
          return;
        }

        if (
          !cart.items ||
          !cart.items.length
        ) {
          body.innerHTML =
            '<div class="bovea-cart-empty">' +
              'Dein Warenkorb ist noch leer.<br>' +
              'Füge deine Lieblingsprodukte hinzu.' +
            '</div>';

          if (foot) {
            foot.innerHTML = "";

            foot.setAttribute(
              "hidden",
              ""
            );
          }

          return;
        }

        /*
          Reihenfolge:
          1. MagClip
          2. Reinigungstücher
          3. gekaufte Produkte
        */
        var visibleItems =
          Engine.displayItems
            ? Engine.displayItems(cart)
            : cart.items;

        var sortedItems =
          visibleItems
            .map(function (
              item,
              index
            ) {
              return {
                item: item,
                index: index,
                priority:
                  giftPriority(item)
              };
            })
            .sort(function (
              first,
              second
            ) {
              if (
                first.priority !==
                second.priority
              ) {
                return (
                  first.priority -
                  second.priority
                );
              }

              return (
                first.index -
                second.index
              );
            })
            .map(function (entry) {
              return entry.item;
            });

        body.innerHTML =
          sortedItems
            .map(itemHtml)
            .join("") +
          extrasHtml(cart);

        if (foot) {
          foot.innerHTML =
            footerHtml(cart);

          foot.removeAttribute(
            "hidden"
          );
        }
      }
    );

    bindQuickScroll();

    window.setTimeout(
      function () {
        renderLock = false;
      },
      80
    );
  }

  /*
    ============================================================
    WARENKORB KOMPLETT AKTUALISIEREN
    ============================================================
  */

  function refresh() {
    return secureGiftSync()
      .then(enrichSavings)
      .then(function (cart) {
        render(cart);
        publishCart(cart);
        return cart;
      })
      .catch(function (error) {
        console.error(
          "BOVEA cart error:",
          error
        );
      });
  }

  /*
    ============================================================
    MENGE ÄNDERN ODER ARTIKEL ENTFERNEN

    Die Buttons arbeiten mit der Variante, nicht mit dem
    Zeilenschluessel. Der Schluessel im HTML kann veraltet
    sein, sobald Shopify den Warenkorb neu aufbaut; dann lief
    die Aenderung frueher ins Leere und das Plus tat nichts.
    Die Variante bleibt dagegen immer gueltig.
    ============================================================
  */

  function changeLine(row, quantity) {
    if (!row) {
      return;
    }

    var variantId = Number(
      row.getAttribute("data-variant-id")
    );

    if (!variantId) {
      return;
    }

    row
      .querySelectorAll("button")
      .forEach(function (button) {
        button.disabled = true;
      });

    setPaidQuantity(
      variantId,
      Math.max(Number(quantity || 0), 0)
    );
  }

  /*
    Plus und Minus rechnen bewusst NICHT mit der Zahl aus dem
    HTML, sondern mit der Menge im echten Warenkorb. Sonst
    zaehlen zwei schnelle Klicks hintereinander doppelt oder
    gar nicht.
  */
  function stepLine(row, delta) {
    if (!row) {
      return;
    }

    var variantId = Number(
      row.getAttribute("data-variant-id")
    );

    if (!variantId) {
      return;
    }

    row
      .querySelectorAll("button")
      .forEach(function (button) {
        button.disabled = true;
      });

    stepPaid(variantId, delta);
  }

  /*
    ============================================================
    SCHNELL HINZUFÜGEN
    ============================================================
  */

  function quickAdd(button) {
    var variantId = Number(
      button.getAttribute("data-variant-id")
    );

    if (!variantId || button.disabled) {
      return;
    }

    button.disabled = true;
    button.textContent = "\u2713";

    stepPaid(variantId, 1).catch(function () {
      button.disabled = false;
      button.textContent = "+";
    });
  }

  /*
    ============================================================
    WARENKORB ÖFFNEN
    ============================================================
  */

  function openDrawer(toggle) {
    var section =
      toggle.closest("section") ||
      document.querySelector(
        "section[id^='LuminoHomepage'], " +
        "section[id^='LuminoProductNord_'], " +
        "section[id^='LuminoCollection']"
      );

    if (section) {
      section.classList.add(
        "cart-open"
      );
    }

    document.documentElement
      .style.overflow = "hidden";

    /*
      Den letzten Stand sofort anzeigen, damit der Drawer ohne
      Ladeblitz aufgeht. Danach aber IMMER den echten Shopify-
      Warenkorb neu laden. Auf der Startseite schreibt der
      Produktbutton direkt per AJAX; latestCart ist in diesem
      Moment noch der Stand vor dem Klick.
    */
    if (latestCart) {
      render(latestCart);
    }

    window.setTimeout(
      refresh,
      140
    );
  }

  /*
    ============================================================
    PUNKTE DER SCHNELLFUNKTION AKTUALISIEREN
    ============================================================
  */

  function bindQuickScroll() {
    document
      .querySelectorAll(
        "[data-bovea-quick-track]"
      )
      .forEach(function (track) {
        if (
          track.dataset
            .boveaBound === "true"
        ) {
          return;
        }

        track.dataset.boveaBound =
          "true";

        track.addEventListener(
          "scroll",
          function () {
            var card =
              track.querySelector(
                ".bovea-quick-card"
              );

            var box =
              track.closest(
                "[data-bovea-quick-box]"
              );

            if (!card || !box) {
              return;
            }

            var width =
              card
                .getBoundingClientRect()
                .width + 12;

            var activeIndex =
              Math.round(
                track.scrollLeft /
                Math.max(width, 1)
              );

            box
              .querySelectorAll(
                ".bovea-quick-dot"
              )
              .forEach(function (
                dot,
                dotIndex
              ) {
                dot.classList.toggle(
                  "is-active",
                  dotIndex ===
                    activeIndex
                );
              });
          },
          {
            passive: true
          }
        );
      });
  }

  /*
    ============================================================
    KLICK-EVENTS
    ============================================================
  */

  function resetCheckoutState() {
    document
      .querySelectorAll(".bovea-checkout")
      .forEach(function (button) {
        button.removeAttribute("aria-busy");
        button.style.pointerEvents = "";
        button.style.opacity = "";
      });
  }

  function cartHasLegacyGift(cartState) {
    return Boolean(
      cartState &&
      Array.isArray(cartState.items) &&
      cartState.items.some(function (item) {
        return isGift(item);
      })
    );
  }

  function goToCheckout() {
    resetCheckoutState();
    window.location.assign("/checkout");
  }

  function checkoutSafely(button) {
    if (!button) {
      return;
    }

    if (button.getAttribute("aria-busy") === "true") {
      resetCheckoutState();
    }

    button.setAttribute("aria-busy", "true");

    /*
      Normalfall: Die aktuelle Promo nutzt keine Geschenke mehr.
      Dann direkt zum Checkout navigieren. So hängt der CTA auf
      iOS nach App-Wechsel / Safari-Resume nicht an einer alten
      AJAX-Queue.
    */
    if (!cartHasLegacyGift(latestCart)) {
      window.location.assign("/checkout");
      return;
    }

    /*
      Nur für alte Warenkörbe mit einem verbliebenen Geschenk
      kurz aufräumen. Selbst wenn Safari einen Request nach dem
      App-Wechsel einfriert, führt der Timeout sicher weiter.
    */
    var finished = false;

    function finish() {
      if (finished) {
        return;
      }

      finished = true;
      window.location.assign("/checkout");
    }

    window.setTimeout(finish, 700);

    Promise.resolve()
      .then(function () {
        return secureGiftSync();
      })
      .then(finish)
      .catch(finish);
  }

  function restoreAfterAppResume() {
    resetCheckoutState();

    if (
      document.visibilityState &&
      document.visibilityState !== "visible"
    ) {
      return;
    }

    /*
      Wenn der Cart offen war, nach Rückkehr aus einer anderen App
      den Shopify-Warenkorb einmal frisch holen. Das verhindert
      eingefrorene Zustände nach iOS-Suspend/BFCache.
    */
    if (
      document.querySelector(".cart-open") ||
      document.body.classList.contains("bovea-cart-open")
    ) {
      window.setTimeout(refresh, 40);
    }
  }

  function bindEvents() {
    document.addEventListener(
      "click",
      function (event) {
        /*
          Warenkorb öffnen
        */
        var toggle =
          event.target.closest(
            ".lh-cart-toggle, " +
            ".lc-cart-toggle, " +
            "a[href='/cart'], " +
            "a[href$='/cart']"
          );

        if (toggle) {
          event.preventDefault();
          openDrawer(toggle);
          return;
        }

        /*
          Schnell hinzufügen
        */
        var addButton =
          event.target.closest(
            "[data-bovea-quick-add]"
          );

        if (addButton) {
          event.preventDefault();
          quickAdd(addButton);
          return;
        }

        /*
          Warenkorbzeile
        */
        var row =
          event.target.closest(
            "[data-bovea-cart-item]"
          );

        if (row) {
          if (
            event.target.closest(
              "[data-bovea-plus]"
            )
          ) {
            event.preventDefault();

            stepLine(row, 1);

            return;
          }

          if (
            event.target.closest(
              "[data-bovea-minus]"
            )
          ) {
            event.preventDefault();

            stepLine(row, -1);

            return;
          }

          if (
            event.target.closest(
              "[data-bovea-remove]"
            )
          ) {
            event.preventDefault();

            changeLine(
              row,
              0
            );

            return;
          }
        }

        /*
          Vor dem Checkout den echten Shopify-Warenkorb noch
          einmal absichern. Unerlaubte oder mehrfach hinzugefuegte
          0-Euro-MagClips werden entfernt, bevor die Weiterleitung
          startet.
        */
        var checkoutButton =
          event.target.closest(
            ".bovea-checkout"
          );

        if (checkoutButton) {
          event.preventDefault();
          checkoutSafely(checkoutButton);
          return;
        }

        /*
          Rabattcode anwenden
        */
        var applyButton =
          event.target.closest(
            "[data-bovea-discount-apply]"
          );

        if (applyButton) {
          /*
            Rabattcodes sind noch nicht scharf geschaltet.
            Der Button bleibt sichtbar, tut aber bewusst nichts.
          */
          event.preventDefault();
          return;
        }

        /*
          Änderungen durch andere Produktbuttons
        */
        var ownAjaxAdd =
          event.target.closest(
            "[data-ajax-add], [data-lumino-add-button]"
          );

        if (ownAjaxAdd) {
          var homepageAdd = ownAjaxAdd.closest(
            "section[id^='LuminoHomepage']"
          );

          /*
            Die Startseite nutzt ihren eigenen AJAX-Add und nicht
            immer window.BoveaCart.add. Deshalb darf hier nicht
            einfach abgebrochen werden. Mehrere zeitversetzte
            Abgleiche fangen schnelle und langsamere Antworten ab,
            ohne die Produkt- oder Collection-Seite anzufassen.
          */
          if (homepageAdd) {
            window.setTimeout(refresh, 120);
            window.setTimeout(refresh, 480);
            window.setTimeout(refresh, 1100);
          }

          return;
        }

        if (
          event.target.closest(
            "[name='add']"
          ) ||
          event.target.closest(
            "[data-cart-plus]"
          ) ||
          event.target.closest(
            "[data-cart-minus]"
          ) ||
          event.target.closest(
            "[data-cart-remove]"
          )
        ) {
          window.setTimeout(
            refresh,
            700
          );
        }
      }
    );
  }

  /*
    ============================================================
    STYLES
    ============================================================
  */

  function injectStyles() {
    if (
      document.getElementById(
        "bovea-cart-beauty-style"
      )
    ) {
      return;
    }

    var style =
      document.createElement(
        "style"
      );

    style.id =
      "bovea-cart-beauty-style";

    style.textContent = `
      .lh-cart-drawer.bovea-cart-beauty,
      .lc-cart-drawer.bovea-cart-beauty {
        width: min(94vw, 430px) !important;
        max-width: 430px !important;
        height: 100dvh !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden !important;
        background: #FAF9F6 !important;
        color: #2F2924 !important;
        font-family: var(--bovea-font-body, Inter, Arial, sans-serif) !important;
      }

      .bovea-cart-beauty *,
      .bovea-cart-beauty-footer *,
      .bovea-cart-beauty-scroll * {
        box-sizing: border-box;
        font-family: var(--bovea-font-body, Inter, Arial, sans-serif) !important;
        font-variant-numeric: lining-nums;
        font-feature-settings: "lnum" 1;
      }

      .bovea-cart-beauty .lh-cart-head,
      .bovea-cart-beauty .lc-cart-head {
        flex: 0 0 auto !important;
        padding: 20px 20px 14px !important;
        border-bottom: 1px solid rgba(47, 41, 36, 0.10) !important;
      }

      .bovea-cart-beauty .lh-cart-title,
      .bovea-cart-beauty .lc-cart-title {
        color: #2F2924 !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        letter-spacing: 0.18em !important;
        text-transform: uppercase !important;
      }

      .bovea-cart-beauty [data-cart-body] {
        flex: 1 1 auto !important;
        min-height: 0 !important;
        overflow-y: auto !important;
        overflow-x: hidden !important;
        padding: 0 !important;
        background: #FAF9F6 !important;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
      }

      .bovea-cart-beauty [data-cart-foot] {
        flex: 0 0 auto !important;
        display: block !important;
        padding: 0 16px 10px !important;
        border-top: 0 !important;
        background: #FAF9F6 !important;
        box-shadow: 0 -8px 22px rgba(47, 41, 36, 0.07) !important;
      }

      .bovea-cart-empty {
        padding: 44px 22px 24px;
        color: #7B6B5C;
        font-size: 14px;
        line-height: 1.45;
        text-align: center;
      }

      .bovea-cart-item {
        display: grid;
        grid-template-columns: 72px minmax(0, 1fr) 66px;
        gap: 12px;
        align-items: start;
        padding: 18px 20px;
        border-bottom: 1px solid rgba(47, 41, 36, 0.08);
        background: #FAF9F6;
      }

      .bovea-cart-item-img {
        width: 72px;
        height: 72px;
        display: block;
        overflow: hidden;
        border-radius: 10px;
        background: #EFE4D5;
      }

      .bovea-cart-item-img img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      .bovea-cart-item-mid {
        min-width: 0;
      }

      .bovea-cart-item-title {
        display: block;
        margin: 0 0 5px;
        color: #2F2924;
        font-size: 14px;
        font-weight: 700;
        line-height: 1.23;
        text-decoration: none;
      }

      .bovea-cart-item-variant {
        max-width: 155px;
        margin: 0 0 10px;
        overflow: hidden;
        color: #7B6B5C;
        font-size: 12.5px;
        line-height: 1.25;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .bovea-cart-qty {
        display: inline-grid;
        grid-template-columns: 32px 38px 32px;
        height: 32px;
        align-items: center;
        overflow: hidden;
        border: 1px solid rgba(47, 41, 36, 0.14);
        border-radius: 9px;
        background: #FAF9F6;
      }

      .bovea-cart-qty button {
        width: 32px;
        height: 32px;
        padding: 0;
        border: 0;
        background: transparent;
        color: #2F2924;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
      }

      .bovea-cart-qty span {
        color: #2F2924;
        font-size: 13px;
        font-weight: 600;
        text-align: center;
      }

      .bovea-cart-item-right {
        width: 66px;
        min-height: 72px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;
        gap: 18px;
      }

      .bovea-cart-item-price {
        color: #2F2924;
        font-size: 14px;
        font-weight: 800;
        white-space: nowrap;
      }

      .bovea-cart-price-stack {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        gap: 2px;
        line-height: 1.05;
        white-space: nowrap;
      }

      .bovea-cart-item-compare {
        color: #8A837B;
        font-size: 11.5px;
        font-weight: 400;
        line-height: 1;
        text-decoration-thickness: 1px;
      }

      .bovea-cart-gift-free {
        color: #16850D !important;
        font-weight: 800 !important;
      }

      .bovea-cart-gift-label {
        display: inline-flex;
        width: fit-content;
        min-height: 28px;
        align-items: center;
        padding: 0 10px;
        border: 1px solid rgba(22, 133, 13, 0.20);
        border-radius: 8px;
        background: rgba(22, 133, 13, 0.07);
        color: #16850D;
        font-size: 11.5px;
        font-weight: 700;
        line-height: 1;
      }

      .bovea-cart-remove {
        padding: 0;
        border: 0;
        background: transparent;
        color: #7B6B5C;
        font-size: 12px;
        font-weight: 400;
        text-decoration: underline;
        cursor: pointer;
      }

      .bovea-cart-remove:disabled,
      .bovea-cart-qty button:disabled,
      .bovea-quick-add:disabled {
        opacity: 0.45;
        cursor: wait;
      }

      .bovea-cart-scroll {
        background: #FAF9F6;
      }

      .bovea-demand-box {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        margin: 10px 20px 0;
        padding: 15px 16px;
        background: #EFEFEF;
        color: #5A5650;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.35;
      }

      .bovea-demand-icon {
        flex: 0 0 auto;
        width: 18px;
        height: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-top: 1px;
        border: 1.3px solid currentColor;
        border-radius: 999px;
        color: #2F2924;
        font-size: 12px;
        font-weight: 700;
        line-height: 1;
      }

      .bovea-quick-box {
        margin: 10px 0 0;
        padding: 16px 0 15px 20px;
        overflow: hidden;
        background: #F2EEA8;
      }

      .bovea-quick-head {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 12px;
        padding: 0 20px 12px 0;
        color: #2F2924;
      }

      .bovea-quick-head strong {
        font-size: 15px;
        font-weight: 800;
      }

      .bovea-quick-head small {
        color: rgba(47, 41, 36, 0.58);
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      .bovea-quick-track {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: calc(100% - 36px);
        gap: 12px;
        overflow-x: auto;
        overflow-y: hidden;
        padding: 0 20px 0 0;
        scroll-snap-type: x mandatory;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
      }

      .bovea-quick-track::-webkit-scrollbar {
        display: none;
      }

      .bovea-quick-card {
        min-width: 0;
        height: 96px;
        display: grid;
        grid-template-columns: 96px minmax(0, 1fr) 46px;
        align-items: center;
        gap: 12px;
        background: #FAF9F6;
        scroll-snap-align: start;
      }

      .bovea-quick-img {
        width: 96px;
        height: 96px;
        display: block;
        overflow: hidden;
        background: #EFE4D5;
      }

      .bovea-quick-img img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      .bovea-quick-info {
        min-width: 0;
      }

      .bovea-quick-title {
        display: block;
        margin: 0 0 7px;
        overflow: hidden;
        color: #2F2924;
        font-size: 14px;
        font-weight: 800;
        line-height: 1.2;
        text-decoration: none;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .bovea-quick-price {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #5A5650;
        font-size: 14px;
        font-weight: 500;
        line-height: 1;
        white-space: nowrap;
      }

      .bovea-quick-price s {
        color: #7F776F;
        font-weight: 400;
      }

      .bovea-quick-add {
        width: 34px;
        height: 34px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: 0;
        border-radius: 999px;
        background: #252525;
        color: #FFFFFF;
        font-size: 27px;
        font-weight: 500;
        line-height: 1;
        cursor: pointer;
      }

      .bovea-quick-dots {
        display: flex;
        justify-content: center;
        gap: 7px;
        padding: 11px 20px 0 0;
      }

      .bovea-quick-dot {
        width: 6px;
        height: 6px;
        border-radius: 999px;
        background: rgba(47, 41, 36, 0.22);
      }

      .bovea-quick-dot.is-active {
        width: 22px;
        background: #252525;
      }

      .bovea-gift-box {
        margin: 0;
        padding: 18px 20px 16px;
        background: #F2EEA8;
      }

      .bovea-demand-box + .bovea-gift-box {
        margin-top: 10px;
      }

      .bovea-gift-title {
        margin: 0 0 14px;
        color: #2F2924;
        font-size: 15px;
        font-weight: 500;
        line-height: 1.45;
      }

      .bovea-gift-title strong {
        font-weight: 800;
      }

      .bovea-gift-progress {
        position: relative;
        height: 8px;
        margin: 0 0 15px;
        border-radius: 999px;
        background: rgba(76, 128, 37, 0.22);
      }

      .bovea-gift-progress span {
        display: block;
        height: 100%;
        border-radius: 999px;
        background: #16850D;
      }

      .bovea-gift-progress em {
        position: absolute;
        top: 50%;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(-50%, -50%);
        border-radius: 999px;
        background: #16850D;
        color: #FFFFFF;
        font-size: 17px;
        font-style: normal;
      }

      .bovea-gift-labels {
        display: flex;
        justify-content: space-between;
        color: #2F2924;
        font-size: 15px;
      }

      .bovea-code-row {
        display: grid;
        grid-template-columns: 1fr 104px;
        gap: 8px;
        margin: 12px 0 10px;
      }

      .bovea-code-input,
      .bovea-code-button {
        height: 44px;
        border-radius: 0;
        font-size: 14px;
      }

      .bovea-code-input {
        width: 100%;
        padding: 0 14px;
        border: 1px solid rgba(47, 41, 36, 0.15);
        background: #FAF9F6;
      }

      .bovea-code-button {
        border: 0;
        background: #252525;
        color: #FFFFFF;
        cursor: pointer;
      }

      .bovea-total-list {
        margin: 0 0 10px;
      }

      .bovea-total-row {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        margin: 0 0 4px;
        color: #5A5650;
        font-size: 14px;
      }

      .bovea-total-row strong {
        color: #2F2924;
        font-weight: 600;
      }

      .bovea-shipping-free {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        color: #16850D !important;
        font-weight: 700 !important;
      }

      .bovea-shipping-free s {
        color: #8A837B;
        font-weight: 400;
      }

      .bovea-discount-row strong {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        color: #B00000 !important;
        font-weight: 700 !important;
      }

      .bovea-discount-icon,
      .bovea-discount-icon svg {
        width: 14px;
        height: 14px;
        display: inline-flex;
      }

      .bovea-total-final {
        margin-top: 8px;
        padding-top: 9px;
        border-top: 1px solid #2F2924;
        color: #2F2924;
        font-size: 16px;
        font-weight: 800;
      }

      .bovea-checkout {
        width: 100%;
        min-height: 50px;
        display: flex !important;
        align-items: center;
        justify-content: center;
        background: #252525 !important;
        color: #FFFFFF !important;
        font-size: 15px !important;
        font-weight: 700 !important;
        text-decoration: none !important;
      }

      .bovea-trust-line {
        margin: 8px 0 0;
        color: #6E6963;
        font-size: 12px;
        line-height: 1.22;
        text-align: center;
      }

      @media screen and (max-width: 749px) {
        .lh-cart-drawer.bovea-cart-beauty,
        .lc-cart-drawer.bovea-cart-beauty {
          width: min(96vw, 430px) !important;
        }

        .bovea-cart-item {
          grid-template-columns: 68px minmax(0, 1fr) 64px;
          gap: 10px;
          padding: 16px;
        }

        .bovea-cart-item-img {
          width: 68px;
          height: 68px;
        }

        .bovea-cart-item-right {
          width: 64px;
        }

        .bovea-demand-box {
          margin-right: 16px;
          margin-left: 16px;
        }

        .bovea-quick-box {
          padding-left: 16px;
        }

        .bovea-quick-track {
          grid-auto-columns: calc(100% - 28px);
        }

        .bovea-quick-card {
          grid-template-columns: 88px minmax(0, 1fr) 42px;
          height: 88px;
          gap: 10px;
        }

        .bovea-quick-img {
          width: 88px;
          height: 88px;
        }
      }

      /* ============================================================
         BOVEA CART V3 — NORDDESIGN-INSPIRIERTE STRUKTUR
         ============================================================ */

      .lh-cart-drawer.bovea-cart-beauty,
      .lc-cart-drawer.bovea-cart-beauty {
        width: min(88vw, 510px) !important;
        max-width: 510px !important;
        background: #FCFBF4 !important;
      }

      .bovea-cart-beauty .lh-cart-head,
      .bovea-cart-beauty .lc-cart-head {
        padding: 24px 24px 18px !important;
        border-bottom: 0 !important;
        background: #FCFBF4 !important;
      }

      .bovea-cart-beauty .lh-cart-title,
      .bovea-cart-beauty .lc-cart-title {
        font-size: 22px !important;
        line-height: 1.1 !important;
        font-weight: 500 !important;
        letter-spacing: -0.025em !important;
        text-transform: none !important;
      }

      .bovea-cart-beauty [data-cart-body] {
        background: #FCFBF4 !important;
      }

      .bovea-cart-beauty [data-cart-foot] {
        padding: 14px 22px 14px !important;
        background: #FCFBF4 !important;
        box-shadow: 0 -7px 18px rgba(47, 41, 36, 0.055) !important;
      }

      .bovea-cart-item {
        grid-template-columns: 108px minmax(0, 1fr) 28px !important;
        gap: 16px !important;
        padding: 18px 24px 16px !important;
        border-bottom: 0 !important;
        background: #FCFBF4 !important;
      }

      .bovea-cart-item-img {
        width: 108px !important;
        height: 108px !important;
        border-radius: 0 !important;
        background: #EFE4D5 !important;
      }

      .bovea-cart-item-title {
        margin-bottom: 3px !important;
        font-size: 15px !important;
        line-height: 1.16 !important;
        font-weight: 750 !important;
      }

      .bovea-cart-item-variant {
        margin-bottom: 5px !important;
        max-width: none !important;
        color: #8A857E !important;
        font-size: 14px !important;
      }

      .bovea-cart-item-mid .bovea-cart-price-stack {
        align-items: flex-start !important;
        margin: 0 0 11px !important;
      }

      .bovea-cart-item-mid .bovea-cart-item-price {
        font-size: 14px !important;
        font-weight: 500 !important;
      }

      .bovea-cart-item-mid .bovea-cart-item-compare {
        font-size: 12px !important;
      }

      .bovea-cart-qty {
        grid-template-columns: 36px 42px 36px !important;
        height: 38px !important;
        border-radius: 0 !important;
        background: #FCFBF4 !important;
      }

      .bovea-cart-qty button {
        width: 36px !important;
        height: 38px !important;
        font-size: 18px !important;
        font-weight: 400 !important;
      }

      .bovea-cart-qty span {
        font-size: 14px !important;
        font-weight: 500 !important;
      }

      .bovea-cart-item-right {
        width: 28px !important;
        min-height: 108px !important;
        align-items: center !important;
        justify-content: flex-end !important;
        padding-bottom: 8px !important;
      }

      .bovea-cart-remove {
        width: 28px !important;
        height: 28px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        color: #2F2924 !important;
        text-decoration: none !important;
      }

      .bovea-cart-remove svg {
        width: 19px !important;
        height: 19px !important;
      }

      .bovea-demand-box {
        margin: 6px 24px 0 !important;
        padding: 13px 15px !important;
        background: #F0F0EF !important;
        color: #66615B !important;
        font-size: 13px !important;
        line-height: 1.35 !important;
      }

      .bovea-shipping-milestone {
        margin: 12px 0 0 !important;
        padding: 18px 24px 17px !important;
        background: #F7F1A0 !important;
        color: #2F2924 !important;
      }

      .bovea-shipping-copy {
        margin: 0 0 13px !important;
        font-size: 15px !important;
        line-height: 1.3 !important;
        font-weight: 450 !important;
      }

      .bovea-shipping-copy strong {
        font-weight: 700 !important;
      }

      .bovea-shipping-progress {
        position: relative !important;
        height: 5px !important;
        margin: 0 0 13px !important;
        border-radius: 999px !important;
        background: rgba(31, 145, 43, .18) !important;
      }

      .bovea-shipping-progress__fill {
        display: block !important;
        height: 100% !important;
        border-radius: inherit !important;
        background: #1F912B !important;
      }

      .bovea-shipping-progress__marker {
        position: absolute !important;
        top: 50% !important;
        width: 30px !important;
        height: 30px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        border: 2px solid #FFFFFF !important;
        border-radius: 999px !important;
        background: #1F912B !important;
        color: #FFFFFF !important;
        box-shadow: 0 2px 6px rgba(31, 145, 43, .24) !important;
        transform: translate(-50%, -50%) !important;
      }

      .bovea-shipping-progress__marker svg {
        width: 17px !important;
        height: 17px !important;
      }

      .bovea-shipping-labels {
        display: flex !important;
        justify-content: space-between !important;
        gap: 12px !important;
        font-size: 14px !important;
        line-height: 1 !important;
        font-weight: 500 !important;
      }

      .bovea-shipping-milestone.is-complete {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
      }

      .bovea-shipping-success {
        display: flex !important;
        flex-direction: column !important;
        gap: 3px !important;
        font-size: 15px !important;
        line-height: 1.25 !important;
      }

      .bovea-shipping-success strong {
        color: #1F912B !important;
        font-size: 15px !important;
        font-weight: 650 !important;
      }

      .bovea-quick-box {
        margin: 0 !important;
        padding: 14px 0 15px 24px !important;
        background: #F7F1A0 !important;
      }

      .bovea-quick-head {
        padding-right: 24px !important;
        padding-bottom: 10px !important;
      }

      .bovea-quick-head strong {
        font-size: 14px !important;
        font-weight: 700 !important;
      }

      .bovea-quick-head small {
        display: none !important;
      }

      .bovea-quick-card {
        height: 92px !important;
        grid-template-columns: 92px minmax(0, 1fr) 46px !important;
        background: #FCFBF4 !important;
      }

      .bovea-quick-img {
        width: 92px !important;
        height: 92px !important;
      }

      .bovea-quick-add {
        width: 38px !important;
        height: 38px !important;
        margin-right: 7px !important;
      }

      .bovea-savings-note {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 12px !important;
        margin: 0 0 12px !important;
        padding: 10px 12px !important;
        background: rgba(31, 145, 43, .08) !important;
        color: #1F912B !important;
        font-size: 13px !important;
        line-height: 1.2 !important;
      }

      .bovea-savings-note strong {
        color: #1F912B !important;
        font-size: 14px !important;
        font-weight: 750 !important;
        white-space: nowrap !important;
      }

      .bovea-total-list {
        margin: 0 0 12px !important;
      }

      .bovea-total-row {
        margin: 0 0 7px !important;
        color: #67615B !important;
        font-size: 15px !important;
        line-height: 1.25 !important;
      }

      .bovea-total-row strong {
        color: #67615B !important;
        font-weight: 500 !important;
      }

      .bovea-shipping-free {
        color: #1F912B !important;
        font-weight: 650 !important;
      }

      .bovea-total-final {
        margin-top: 10px !important;
        padding-top: 10px !important;
        border-top: 1px solid #2F2924 !important;
        color: #2F2924 !important;
        font-size: 17px !important;
        font-weight: 750 !important;
      }

      .bovea-total-final strong {
        color: #2F2924 !important;
        font-weight: 750 !important;
      }

      .bovea-checkout {
        min-height: 54px !important;
        font-size: 17px !important;
        font-weight: 500 !important;
      }

      .bovea-trust-line {
        margin-top: 8px !important;
        font-size: 11.5px !important;
      }

      @media screen and (max-width: 749px) {
        .lh-cart-drawer.bovea-cart-beauty,
        .lc-cart-drawer.bovea-cart-beauty {
          width: min(88vw, 410px) !important;
        }

        .bovea-cart-beauty .lh-cart-head,
        .bovea-cart-beauty .lc-cart-head {
          padding: 21px 18px 15px !important;
        }

        .bovea-cart-beauty [data-cart-foot] {
          padding: 12px 18px 12px !important;
        }

        .bovea-cart-item {
          grid-template-columns: 96px minmax(0, 1fr) 25px !important;
          gap: 12px !important;
          padding: 16px 18px 14px !important;
        }

        .bovea-cart-item-img {
          width: 96px !important;
          height: 96px !important;
        }

        .bovea-cart-item-right {
          width: 25px !important;
          min-height: 96px !important;
        }

        .bovea-demand-box {
          margin-right: 18px !important;
          margin-left: 18px !important;
        }

        .bovea-shipping-milestone {
          padding-right: 18px !important;
          padding-left: 18px !important;
        }

        .bovea-quick-box {
          padding-left: 18px !important;
        }
      }

/* === BOVEA CART CTA UX START === */

      /* Produktzeile kompakter: Preis + Menge auf einer Linie */
      .bovea-cart-item-actions {
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 12px !important;
        margin-top: 8px !important;
        min-width: 0 !important;
        flex-wrap: nowrap !important;
      }

      .bovea-cart-item-actions .bovea-cart-price-stack {
        margin: 0 !important;
        flex: 0 0 auto !important;
        min-width: max-content !important;
      }

      .bovea-cart-item-actions .bovea-cart-qty {
        margin: 0 !important;
        flex: 0 0 auto !important;
      }

      /* CTA: dunkles Waldgrün fügt sich in Creme/Gelb/Grün ein,
         wirkt vertrauensvoller als Schwarz und bleibt hochwertig. */
      .bovea-checkout {
        min-height: 58px !important;
        gap: 9px !important;
        border-radius: 8px !important;
        background: #2F6B3C !important;
        color: #FFFFFF !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        letter-spacing: -0.01em !important;
        box-shadow: 0 8px 18px rgba(47, 107, 60, .18) !important;
        transition: background .18s ease, transform .18s ease, box-shadow .18s ease !important;
      }

      .bovea-checkout:hover {
        background: #285C34 !important;
        box-shadow: 0 10px 22px rgba(47, 107, 60, .22) !important;
      }

      .bovea-checkout:active {
        transform: translateY(1px) !important;
      }

      .bovea-checkout-lock {
        width: 18px !important;
        height: 18px !important;
        flex: 0 0 18px !important;
      }

      @media screen and (max-width: 749px) {
        .bovea-cart-item-actions {
          gap: 10px !important;
          margin-top: 6px !important;
        }

        .bovea-cart-item-actions .bovea-cart-qty {
          grid-template-columns: 31px 35px 31px !important;
          height: 34px !important;
        }

        .bovea-cart-item-actions .bovea-cart-qty button {
          width: 31px !important;
          height: 34px !important;
          font-size: 17px !important;
        }

        .bovea-cart-item-actions .bovea-cart-qty span {
          font-size: 13px !important;
        }

        .bovea-checkout {
          min-height: 56px !important;
          font-size: 16px !important;
        }
      }

/* === BOVEA CART CTA UX END === */

/* === BOVEA SHIPPING UI V2 START === */
      .bovea-shipping-copy {
        display: flex !important;
        flex-direction: column !important;
        gap: 4px !important;
      }

      .bovea-shipping-rate {
        color: #2F2924 !important;
        font-size: 14px !important;
        line-height: 1.2 !important;
        font-weight: 750 !important;
      }

      .bovea-shipping-copy > span {
        color: #5F5A54 !important;
        font-size: 12.5px !important;
        line-height: 1.35 !important;
        font-weight: 450 !important;
      }
/* === BOVEA SHIPPING UI V2 END === */

/* === BOVEA CART ITEM ALIGNMENT V7 START === */
      /* Preis oben rechts, Menge links. Textspalte darf niemals in Preis laufen. */
      .bovea-cart-item {
        grid-template-columns: 108px minmax(0, 1fr) 92px !important;
      }

      .bovea-cart-item-mid {
        min-width: 0 !important;
        max-width: 100% !important;
        overflow: hidden !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-start !important;
      }

      .bovea-cart-item-title {
        width: 100% !important;
        max-width: 100% !important;
        overflow: hidden !important;
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 2 !important;
        line-clamp: 2 !important;
        text-overflow: ellipsis !important;
      }

      .bovea-cart-item-variant {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        white-space: nowrap !important;
      }

      .bovea-cart-item-mid .bovea-cart-qty {
        align-self: flex-start !important;
        margin: 10px 0 0 !important;
      }

      .bovea-cart-item-right {
        width: 92px !important;
        min-width: 92px !important;
        min-height: 108px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-end !important;
        justify-content: space-between !important;
        gap: 14px !important;
        padding: 0 0 8px !important;
      }

      .bovea-cart-item-right .bovea-cart-price-stack {
        width: 100% !important;
        margin: 0 !important;
        align-items: flex-end !important;
        text-align: right !important;
        line-height: 1.05 !important;
      }

      .bovea-cart-item-right .bovea-cart-item-price {
        font-size: 14px !important;
        font-weight: 650 !important;
        line-height: 1.05 !important;
        white-space: nowrap !important;
      }

      .bovea-cart-item-right .bovea-cart-item-compare {
        margin-top: 3px !important;
        font-size: 11.5px !important;
        line-height: 1 !important;
        white-space: nowrap !important;
      }

      @media screen and (max-width: 749px) {
        .bovea-cart-item {
          grid-template-columns: 96px minmax(0, 1fr) 86px !important;
          gap: 10px !important;
        }

        .bovea-cart-item-right {
          width: 86px !important;
          min-width: 86px !important;
          min-height: 96px !important;
        }

        .bovea-cart-item-mid .bovea-cart-qty {
          margin-top: 8px !important;
        }

        .bovea-cart-item-title {
          font-size: 14px !important;
          line-height: 1.18 !important;
        }

        .bovea-cart-item-variant {
          font-size: 12.5px !important;
          line-height: 1.2 !important;
          margin-bottom: 0 !important;
        }
      }

      @media screen and (max-width: 390px) {
        .bovea-cart-item {
          grid-template-columns: 84px minmax(0, 1fr) 82px !important;
          gap: 9px !important;
        }

        .bovea-cart-item-img {
          width: 84px !important;
          height: 84px !important;
        }

        .bovea-cart-item-right {
          width: 82px !important;
          min-width: 82px !important;
          min-height: 84px !important;
        }

        .bovea-cart-item-right .bovea-cart-item-price {
          font-size: 13.5px !important;
        }

        .bovea-cart-item-right .bovea-cart-item-compare {
          font-size: 10.5px !important;
        }
      }
/* === BOVEA CART ITEM ALIGNMENT V7 END === */

    `;

    document.head.appendChild(
      style
    );
  }

  /*
    ============================================================
    ALTE WARENKORB-RENDER-VORGÄNGE ABFANGEN
    ============================================================
  */

  function observeOldRenders() {
    var observer =
      new MutationObserver(
        function () {
          if (
            renderLock ||
            !latestCart
          ) {
            return;
          }

          window.clearTimeout(
            observerTimer
          );

          observerTimer =
            window.setTimeout(
              function () {
                bodies().forEach(
                  function (body) {
                    if (
                      !body.querySelector(
                        "[data-bovea-cart-item]"
                      ) &&
                      latestCart &&
                      latestCart.items &&
                      latestCart.items
                        .length
                    ) {
                      /*
                        Nur neu zeichnen, nichts schreiben.
                        Frueher stiess eine fremde DOM-
                        Aenderung hier einen kompletten
                        Warenkorb-Abgleich an.
                      */
                      render(latestCart);
                    }
                  }
                );
              },
              120
            );
        }
      );

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  /*
    ============================================================
    START
    ============================================================
  */

  /*
    ============================================================
    OEFFENTLICHE SCHNITTSTELLE

    Alles, was am Warenkorb schreibt (Produktseiten-Button,
    Upsell, Schnell-Hinzufuegen, Plus, Minus, Entfernen),
    laeuft ausschliesslich hierueber.

    Zwei Regeln machen das System berechenbar:

    1. Jede Aenderung wird gegen einen FRISCH geholten
       Warenkorb aufgeloest. Nichts arbeitet mit Zahlen oder
       Schluesseln, die im HTML stehen und veraltet sein
       koennen.
    2. Pro Variante gibt es genau eine bezahlte Zeile. Kommt
       derselbe Artikel noch einmal dazu, wird die Menge
       dieser Zeile erhoeht, nie eine zweite Zeile angelegt.
    ============================================================
  */

  function publishCart(cart) {
    if (!cart) {
      return cart;
    }

    try {
      window.dispatchEvent(
        new CustomEvent(
          "bovea:cart-updated",
          {
            detail: {
              cart: cart
            }
          }
        )
      );
    } catch (error) {
      /* Aeltere Browser ignorieren das Event. */
    }

    return cart;
  }

  /*
    Nach jeder Schreiboperation immer derselbe Abschluss:
    Geschenke abgleichen, Vergleichspreise und Ersparnis
    ergaenzen, Drawer zeichnen, Meilensteinleiste informieren.
  */
  function finish(cart) {
    return secureGiftSync(cart)
      .then(enrichSavings)
      .then(function (fresh) {
        render(fresh);
        return publishCart(fresh);
      });
  }

  /*
    Bringt die SUMME aller bezahlten Shopify-Zeilen einer
    Variante auf die Zielmenge. Automatische Rabatte duerfen
    intern mehrere Zeilen erzeugen; die Engine veraendert nur
    die notwendige echte Zeile und die Anzeige fasst alles
    anschliessend wieder zu einer Produktzeile zusammen.
  */
  function applyPaidQuantity(cart, variantId, target, properties) {
    var updates = Engine.paidQuantityUpdates(
      cart,
      variantId,
      target
    );

    if (updates === null) {
      if (target <= 0) {
        return Promise.resolve(cart);
      }

      var payload = {
        id: Number(variantId),
        quantity: target
      };

      /*
        Eigenschaften nur mitschicken, wenn es wirklich welche
        gibt. Geschenkmarkierungen werden hier niemals gesetzt;
        ein selbst gekauftes Geschenk bleibt deshalb eine eigene
        bezahlte Zeile.
      */
      if (
        properties &&
        Object.keys(properties).length
      ) {
        payload.properties = properties;
      }

      return postCart("/cart/add.js", payload)
        .then(function () {
          /* /cart/add.js liefert nur die neue Zeile. */
          return getCart();
        });
    }

    if (!Object.keys(updates).length) {
      return Promise.resolve(cart);
    }

    var updateKeys = Object.keys(updates);

    /*
      Ein normaler Plus-/Minus-Schritt betrifft nur eine echte
      Shopify-Zeile. Dafuer change.js verwenden, damit Shopify
      die Mengen- und Bestandspruefung beibehaelt. Nur wenn beim
      kompletten Entfernen mehrere intern geteilte Rabattzeilen
      gleichzeitig auf 0 muessen, kommt update.js zum Einsatz.
    */
    if (updateKeys.length === 1) {
      return postCart(
        "/cart/change.js",
        {
          id: updateKeys[0],
          quantity: updates[updateKeys[0]]
        }
      );
    }

    return postCart(
      "/cart/update.js",
      {
        updates: updates
      }
    );
  }

  /* Absolute Menge setzen. 0 entfernt den Artikel. */
  function setPaidQuantity(variantId, quantity, properties) {
    if (isProtectedMagClipVariant(variantId)) {
      return refresh();
    }

    var target = Math.max(
      Number(quantity || 0),
      0
    );

    if (!variantId) {
      return Promise.reject(
        new Error("Variante fehlt")
      );
    }

    return enqueue(function () {
      var source = latestCart
        ? Promise.resolve(latestCart)
        : getCart();

      return source.then(function (cart) {
        return applyPaidQuantity(
          cart,
          variantId,
          target,
          properties
        );
      });
    })
      .then(finish)
      .catch(function () {
        return refresh();
      });
  }

  /*
    Menge um einen Schritt aendern. Grundlage ist die Menge im
    echten Warenkorb, nicht die Zahl auf dem Bildschirm.
  */
  function stepPaid(variantId, delta, properties) {
    if (isProtectedMagClipVariant(variantId)) {
      return refresh();
    }

    var step = Number(delta || 0);

    if (!variantId || !step) {
      return Promise.reject(
        new Error("Ungueltiger Schritt")
      );
    }

    return enqueue(function () {
      var source = latestCart
        ? Promise.resolve(latestCart)
        : getCart();

      return source.then(function (cart) {
        var current = Engine.paidQuantity(
          cart,
          variantId
        );

        return applyPaidQuantity(
          cart,
          variantId,
          Math.max(current + step, 0),
          properties
        );
      });
    })
      .then(finish)
      .catch(function () {
        return refresh();
      });
  }

  window.BoveaCart = {
    /*
      Werte fuer die Anzeige. Einzige Quelle fuer Schwelle
      und Geschenkwerte.
    */
    config: function () {
      return {
        limit: GIFT_LIMIT,
        shipping: SHIPPING_COMPARE_PRICE,
        giftValues: giftValues(),
        gifts: giftConfig().gifts
      };
    },
    engine: function () {
      return Engine;
    },
    get: getCart,
    enrich: enrichSavings,
    sync: secureGiftSync,
    refresh: refresh,

    /*
      Hinzufuegen. payload: { id, quantity, properties }
      Liegt die Variante schon bezahlt im Warenkorb, wird
      ihre Menge erhoeht.
    */
    add: function (payload) {
      var variantId = Number(payload && payload.id);

      if (isProtectedMagClipVariant(variantId)) {
        return refresh();
      }

      return stepPaid(
        variantId,
        Math.max(
          Number((payload && payload.quantity) || 1),
          1
        ),
        payload && payload.properties
      );
    },
    step: stepPaid,
    set: setPaidQuantity,

    /*
      Menge einer Zeile setzen. Nimmt einen Zeilenschluessel
      oder direkt eine Variante entgegen und loest beides
      gegen den aktuellen Warenkorb auf.
    */
    change: function (idOrKey, quantity) {
      var source = latestCart
        ? Promise.resolve(latestCart)
        : getCart();

      return source.then(function (cart) {
        var line = null;

        (cart.items || []).some(function (item) {
          if (String(item.key) === String(idOrKey)) {
            line = item;
            return true;
          }

          return false;
        });

        if (!line) {
          (cart.items || []).some(function (item) {
            if (
              !Engine.isGift(item) &&
              Engine.variantKeyOf(item) === String(idOrKey)
            ) {
              line = item;
              return true;
            }

            return false;
          });
        }

        if (!line) {
          return refresh();
        }

        if (Engine.isGift(line)) {
          /* Geschenke regelt allein die Engine. */
          return refresh();
        }

        return setPaidQuantity(
          Number(line.variant_id),
          quantity
        );
      });
    },
    publish: publishCart,
    open: function () {
      openDrawer(document.body);
    }
  };

  function resolveGiftDisplayUrl(kind, query, excludedProductId) {
    window.BoveaGiftDisplayUrls = window.BoveaGiftDisplayUrls || {};

    var current = String(window.BoveaGiftDisplayUrls[kind] || "");

    /* Ein bereits von Liquid aufgeloester Produktlink ist die beste Quelle. */
    if (current && current.indexOf("/search?") !== 0) {
      return Promise.resolve(current);
    }

    var endpoint =
      "/search/suggest.json?q=" +
      encodeURIComponent(query) +
      "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last";

    return fetch(endpoint, {
      headers: {
        "Accept": "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Produktsuche nicht erreichbar");
        }

        return response.json();
      })
      .then(function (payload) {
        var products =
          payload &&
          payload.resources &&
          payload.resources.results &&
          payload.resources.results.products
            ? payload.resources.results.products
            : [];

        var product = null;

        products.some(function (candidate) {
          if (
            excludedProductId &&
            Number(candidate && candidate.id) === Number(excludedProductId)
          ) {
            return false;
          }

          if (!candidate) {
            return false;
          }

          product = candidate;
          return true;
        });

        if (!product) {
          return current;
        }

        var url =
          product.url ||
          (product.handle ? "/products/" + product.handle : "");

        if (!url) {
          return current;
        }

        window.BoveaGiftDisplayUrls[kind] = url;

        Array.prototype.slice.call(
          document.querySelectorAll(
            '[data-bovea-gift-link="' + kind + '"]'
          )
        ).forEach(function (link) {
          link.setAttribute("href", url);
        });

        return url;
      })
      .catch(function () {
        return current;
      });
  }

  function resolveGiftDisplayUrls() {
    return Promise.all([
      resolveGiftDisplayUrl(
        "magclip",
        "MagClip Kabel Organizer 6er Set",
        MAGCLIP_PRODUCT_ID
      ),
      resolveGiftDisplayUrl(
        "towels",
        "Reinigungstücher 6er Set",
        0
      )
    ]).then(function () {
      if (latestCart) {
        render(latestCart);
      }
    });
  }

  function init() {
    injectStyles();
    bindEvents();
    observeOldRenders();

    window.addEventListener("pageshow", restoreAfterAppResume);
    window.addEventListener("focus", restoreAfterAppResume);

    document.addEventListener(
      "visibilitychange",
      function () {
        if (document.visibilityState === "visible") {
          restoreAfterAppResume();
        }
      }
    );

    resetCheckoutState();
    resolveGiftDisplayUrls();
    refresh();

    loadQuickProducts().then(function () {
      if (latestCart) {
        render(latestCart);
      }
    });
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );
  } else {
    init();
  }
  /*
    Warenkorbzustand auf den Body spiegeln, damit sich der
    Sticky-Button der Produktseite ausblenden kann.
  */
  function syncBodyCartState() {
    document.body.classList.toggle(
      "bovea-cart-open",
      Boolean(document.querySelector(".cart-open"))
    );
  }

  if (window.MutationObserver) {
    new MutationObserver(syncBodyCartState).observe(
      document.documentElement,
      {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"]
      }
    );
  }

  document.addEventListener(
    "DOMContentLoaded",
    syncBodyCartState
  );

  syncBodyCartState();

})();

